import { Component, inject, OnDestroy, Signal } from '@angular/core';
import {
  DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoForm
} from './forms/decision-on-determining-the-location-of-a-public-purpose-investment-terrain-info.form';
import { Store } from '@ngrx/store';
import { ActivatedRoute, Router } from '@angular/router';
import {
  selectApplication,
  selectLoading,
  selectPending
} from '../../../../../../store/selectors/application.selectors';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { Subscription } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { updateParcels } from '../../../../../../store/actions/application.actions';
import { stages } from '../../decision-on-determining-the-location-of-a-public-purpose-investment.routes';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { ParcelsCrudComponent } from '../../../common/components/parcels/parcels-crud/parcels-crud.component';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-decision-on-determining-the-location-of-a-public-purpose-investment-terrain-info-section',
  standalone: true,
  imports: [
    StagesComponent,
    SpinnerComponent,
    ReactiveFormsModule,
    CommonModule,
    ValidationErrorsComponent,
    ParcelsCrudComponent,
    NgxMaskDirective
  ],
  providers: [DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoForm],
  templateUrl: './decision-on-determining-the-location-of-a-public-purpose-investment-terrain-info-section.component.html'
})
export class DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoSectionComponent implements OnDestroy {

  private store$: Store = inject(Store);

  private route: ActivatedRoute = inject(ActivatedRoute);

  private router: Router = inject(Router);

  public form: DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoForm = inject(DecisionOnDeterminingTheLocationOfAPublicPurposeInvestmentTerrainInfoForm);

  public stages: string[] = stages;

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  public application: Signal<ApplicationAppEntityApplicationRead | null> = this.store$.selectSignal(selectApplication);

  private fetchApplication: Subscription = toObservable(this.application).subscribe(app => {
    if (app) {
      this.form.patchFormValues(app);
    }
  });

  public submitAndGoNext(): void {
    if (this.form.valid) {
      const currentApp = this.application();
      if (currentApp) {
        this.store$.dispatch(
          updateParcels({
            currentApp,
            payload: this.form.toWriteModel(),
            parcels: this.form.parcelsValues,
            successFnc: (applicationId: string) => {
              this.router.navigate(
                ['../charakterystyka-inwestycji'],
                {
                  relativeTo: this.route
                }
              );
            },
            failureFnc: () => {
            },
            tag: 'parcels'
          })
        );
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  public onCancel(): void {
    this.router.navigate(['../dane-wniosku'], { relativeTo: this.route });
  }

  public ngOnDestroy(): void {
    this.fetchApplication.unsubscribe();
  }
}
